import React from 'react';
import { QuestionnaireQuestion } from '../../services/sowConversationService';
import { TextQuestion } from './TextQuestion';
import { MultipleChoiceQuestion } from './MultipleChoiceQuestion';
import { ImageQuestion } from './ImageQuestion';
import { CombinedQuestion } from './CombinedQuestion';

export type QuestionType = 'text' | 'multiple_choice' | 'image' | 'combined';

interface QuestionProps {
  question: QuestionnaireQuestion;
  onContinue: (response: string, imageIds?: string[]) => Promise<void>;
  onImageUpload?: (file: File) => Promise<string>;
  onImageUploaded?: () => void;
  onImageAssessment?: (imageId: string, questionId: string, attemptNumber: number) => Promise<any>;
  isSubmitting: boolean;
}

export const Question: React.FC<QuestionProps> = ({
  question,
  onContinue,
  onImageUpload,
  onImageUploaded,
  onImageAssessment,
  isSubmitting
}) => {
  const determineQuestionType = (question: QuestionnaireQuestion): QuestionType => {
    const hasOptions = question.options && question.options.length > 0;
    const questionType = (question as any).type;
    
    // Drive completely off of type field
    if (questionType === 'image_upload') {
      return 'image';
    } else if (hasOptions) {
      return 'multiple_choice';
    } else {
      return 'text';
    }
  };

  const questionType = determineQuestionType(question);

  const commonProps = {
    question,
    onContinue,
    onImageUpload,
    onImageUploaded,
    onImageAssessment,
    isSubmitting
  };

  switch (questionType) {
    case 'text':
      return <TextQuestion {...commonProps} />;
    case 'multiple_choice':
      return <MultipleChoiceQuestion {...commonProps} />;
    case 'image':
      return <ImageQuestion {...commonProps} />;
    case 'combined':
      return <CombinedQuestion {...commonProps} />;
    default:
      return <TextQuestion {...commonProps} />;
  }
};